module.exports = __webpack_public_path__ + "static/media/instagram.15bc5470.svg";